import {Typography} from '@yandex-delivery/ui'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import React from 'react'

type Props = {
  subtitle: string
  small?: boolean
}

export function Subtitle({subtitle, small}: Props) {
  return (
    <Typography
      color={small ? 'textMinor' : 'text'}
      density="tight"
      level={small ? 'caption1' : 'body2'}
      weight="regular"
    >
      <SafeHTML html={subtitle} />
    </Typography>
  )
}
